import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import jwt_decode from "jwt-decode";
import {css} from "@emotion/core";
import {confirmAlert} from "react-confirm-alert"
import {BeatLoader} from "react-spinners";
import axios from "axios";
import gstMap from '../../assets/GST_map.csv';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function formatNumber (num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
class PartyCode extends Component{
    constructor(props) {
        super(props);
        this.state={
            table:{},
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            monthID:'042020',
            user_id:'',
            is_download:true,
            merchant_name:'Reliance Retail Limited',
            stable:{},
            selectedFile: null,
            changedItems:[],
            isChange: false,
            loading: false

        }
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.get_inactive_btid_data();
        }
        else if(decoded.object_type=='Merchant') {
            this.get_inactive_btid_data();
        }
        else if(decoded.object_type=='Chain') {
            this.get_inactive_btid_data();
        }
        else if(decoded.object_type=='Store') {
            this.get_inactive_btid_data();

        }
    }
    get_inactive_btid_data(){
        $('#partyCodeTable').html('');
        let postData = {
            entity: "gst-master",
            sub_entity: "gst-master-party-code-mapping",
        };

        var inactUtidDataTable = '';
        if ($.fn.DataTable.isDataTable('#partyCodeTable')) {
            $('#partyCodeTable').DataTable().clear().destroy();
        }

        inactUtidDataTable = $('#partyCodeTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "bInfo": false,
                "paging": true,
                "pageLength": 20,
                "autoWidth": false,
                "responsive": false,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/additional_view",
                    type: 'POST',
                    data: postData,
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns: [
                    {sTitle: "", mData: "gst_master_map_id"},

                    {sTitle: "Counter Party Type", mData: "Counter Party Type"},
                    {sTitle: "Billing Company", mData: "Billing Company"},
                    {sTitle: "GST", mData: "GST"},
                    {sTitle: "State", mData: "State"},
                    {sTitle: "Counter Party Code", mData: "Counter Party Code"},

                ],
                columns: [
                    {"data": "gst_master_map_id"},
                    {"data": "Counter Party Type"},
                    {"data": "Billing Company"},
                    {"data": "GST"},
                    {"data": "State"},
                    {"data": "Counter Party Code"},



                ],
                "columnDefs": [
                    {
                        "width": "10px",
                        "targets": 0,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text("");

                            $(td).append("<input type='checkbox'>");
                            $(td).click(e => {
                                this.check_req(e,rowData["gst_master_map_id"]);
                            })
                        },
                        bSortable: false,
                    },




                ],
                // "footerCallback": function ( row, data, start, end, display ) {
                //     var api = this.api(), data;
                //
                //     // Remove the formatting to get integer data for summation
                //     var intVal = function ( i ) {
                //         return typeof i === 'string' ?
                //             i.replace(/[\$,]/g, '')*1 :
                //             typeof i === 'number' ?
                //                 i : 0;
                //     };
                //
                //     // Total over all pages
                //     total = api
                //         .column( 3 )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //     let totalCount = api
                //         .column( 3 )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //
                //     // Total over this page
                //     pageTotal = api
                //         .column( 3, { page: 'current'} )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //     let pageTotalCount = api
                //         .column( 2, { page: 'current'} )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //
                //     // Update footer
                //     $( api.column( 3 ).footer() ).html(
                //         ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                //     );
                //     $( api.column( 2 ).footer() ).html(
                //         ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                //     );
                // },

            });

        this.setState({
            stable: inactUtidDataTable
        });


    }
    check_req(e, rowData){
        let item_list = this.state.changedItems
        let checked_list = rowData;
        console.log(checked_list);
        if(e.target.checked===true) {
            this.setState({
                changedItems: [...this.state.changedItems,  rowData],
                isChange: true
            });
        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                this.setState({
                    changedItems: item_list,
                    isChange: true
                })
            }
        }

        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    deleteItems(){
        if(Array.isArray(this.state.changedItems) && this.state.changedItems.length){
            confirmAlert({
                title: 'Question',
                message: 'Are you sure you want to Delete?.',
                buttons: [{
                    label: 'Yes',
                    onClick: () => {
                        this.handleClickDelete();
                    }
                },
                    {
                        label: 'No',
                    }
                ]
            });
        }
        else{
            this.handleNotificationClick("tr", 3, "Please select at least one record");
        }
    }
    handleClickDelete(){
        axios.post(config.get('API_URL')+'/invoice/additional_delete/',
            {
                entity: "gst-master",
                sub_entity: "gst-master-party-code-mapping",
                delete_keys: this.state.changedItems
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                console.log(response);
                this.get_inactive_btid_data();
            }).catch( err=> {
            console.log(err);
        })
    }

    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    onChangeHandler=event=>{
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if(ext=='csv' || ext=='csv') {
            this.setState({
                selectedFile: file
            });
        } else{
            alert("Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }

    };
    fileUploadHandler = () => {
        // if(this.state.selectedFile===null) {
        //     alert("Please upload valid file");
        //     return false;
        // }
        this.setState({
            isSubmit:true,
            loading:true
        });
        var monthly = this.state.mvalue;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('entity', "gst-master");
        data.append('sub_entity', "gst-master-party-code-mapping");

        var file = this.state.selectedFile; //console.log(data);
        var ext = this.getFileExtension(file.name);
        if(ext=='csv' || ext=='xls') {
            axios.post(config.get('API_URL')+"/invoice/upload_additional_data", data,{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log(res);
                    if(res.data){
                        this.get_inactive_btid_data();
                        alert(res.data);
                        //this.handleNotificationClick("tr", 1, res.data.success);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    } else {
                        alert("File upload failed");
                        //this.handleNotificationClick("tr", 3, res.data.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    }
                })
                .catch(err => { // then print response status
                    //this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                })
        }
        else{
            //this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit:false,
                loading:false
            })
        }
    };

    render() { //console.log(this.state.changedItems);
        return(
            <div className="row tansactionTabs">

                <form method="post" action="#" id="#">
                    <div className="file-up-label">
                        <label className="">Upload Your CSV FIle</label>
                    </div>
                    <div className="file-up-cont">
                        <input type="file" name="file" className="choose-csv-file" onChange={this.onChangeHandler} />
                    </div>
                    <div className="left-button-s">
                        <button type="button" className="btn btn-primary" onClick={this.fileUploadHandler} >Upload File</button>
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={10}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>

                    </div>
                    <div className="col-md-3">
                        <a href={gstMap} download="GST_map.csv" className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                    </div>
                    <div className="col-md-1 pull-right mar-r-15">
                        <button type="button" className="btn btn-primary" onClick={this.deleteItems.bind(this)} disabled={!this.state.isChange}>Delete</button>
                    </div>
                    {/*<div className="col-md-3 pull-left">*/}
                    {/*    */}
                    {/*</div>*/}
                    <div className="clearfix"></div>
                </form>

                <div className="content-tdetails-table table-full-width table-responsive">
                    <table id="partyCodeTable" className="table table-striped table-hover">
                        {/*<tfoot>*/}
                        {/*<tr>*/}
                        {/*    <th>Total:</th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*</tr>*/}
                        {/*</tfoot>*/}
                    </table>
                </div>
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default PartyCode